"use client"

import { useEffect, useState } from "react"
import LocationDropdown from "components/LocationDropdown/LocationDropdown"
import { Box, TextField, InputAdornment } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import { setSelectedLocation, setLocations } from "redux/actions/LocationDropdown"
import { useDispatch, useSelector } from "react-redux"
import { getServiceCity } from "redux/actions/UserServiceCity"
import CommonFilter from "components/commonFilter/CommonFilter"

export default function LiveTrackingHeader({
  handleLocationChange,
  total,
  onTrip,
  onDuty,
  offDuty,
  statusFilters,
  setStatusFilters,
  searchQuery,
  setSearchQuery,
}) {
  const dispatch = useDispatch()
  const locations = useSelector((state) => state?.locationDropdown?.locations || [])
  const selectedLocation = useSelector((state) => state?.locationDropdown?.selectedLocation)
  const Location = useSelector((state) => state?.userServiceCity?.userServiceCity?.data)

  // Convert statusFilters object to array format for CommonFilter
  const [selectedFilterValues, setSelectedFilterValues] = useState([])

  useEffect(() => {
    if (!Location || Location.length === 0) {
      dispatch(getServiceCity())
      return
    }
    if (locations.length === 0 && Location?.length > 0) {
      dispatch(setLocations(Location))
    }
    const defaultLocation = Location.find((city) => city.name === "Bengaluru")
    if (defaultLocation) {
      dispatch(setSelectedLocation(defaultLocation))
    }
  }, [Location, locations, dispatch])

  // Convert statusFilters to array format when it changes
  useEffect(() => {
    const filterArray = []
    if (statusFilters.onTrip) filterArray.push("onTrip")
    if (statusFilters.onDuty) filterArray.push("onDuty")
    if (statusFilters.offDuty) filterArray.push("offDuty")
    setSelectedFilterValues(filterArray)
  }, [statusFilters])

  // Filter data structure for CommonFilter
  const filterData = [
    {
      id: 1,
      primaryText: "Status",
      subItems: [
        { value: "onTrip", list: "On Going" },
        { value: "onDuty", list: "On Duty" },
        { value: "offDuty", list: "Off Duty" },
      ],
    },
  ]

  const handleFilterChange = (selectedValues) => {
    // Convert array back to object format
    const newFilters = {
      onTrip: selectedValues.includes("onTrip"),
      onDuty: selectedValues.includes("onDuty"),
      offDuty: selectedValues.includes("offDuty"),
    }
    setStatusFilters(newFilters)
  }

  const handleResetFilter = () => {
    setStatusFilters({
      onDuty: true,
      onTrip: true,
      offDuty: true,
    })
  }

  return (
    <div className="live-tracking-header">
      <div className="live-tracking-header__title-section">{/* Optional: Title */}</div>

      <div className="live-tracking-header">
        <LocationDropdown onChange={handleLocationChange} className="location-dropdown" defaultCity="Bengaluru" />
        <div className="live-tracking-header__status-section live-tracking-header__status-pill">
          {statusFilters.onTrip && (
            <div className="live-tracking-header__status-pill">
              <div className="status-dot status-dot--ongoing"></div>
              <span>On Going ({onTrip})</span>
            </div>
          )}
          {statusFilters.onDuty && (
            <div className="live-tracking-header__status-pill">
              <div className="status-dot status-dot--onduty"></div>
              <span>On Duty ({onDuty})</span>
            </div>
          )}
          {statusFilters.offDuty && (
            <div className="live-tracking-header__status-pill">
              <div className="status-dot status-dot--offduty"></div>
              <span>Off Duty ({offDuty})</span>
            </div>
          )}
        </div>
        <Box sx={{ width: 280, ml: 2, position: 'relative' }}>
          <span style={{ fontSize: '10px', color: '#757575', position: 'absolute', top: '-16px', left: 0 }}>
            Search by Trip ID, Driver Name, Mobile, or Vehicle No.
          </span>
          <TextField
            size="small"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            fullWidth
          />
        </Box>
         <Box sx={{ width: "auto" }} style={{ marginLeft: "15px" }}>
          <CommonFilter
            filterdata={filterData}
            defaultStatus={selectedFilterValues}
            onFilterChange={handleFilterChange}
            onRestFilter={handleResetFilter}
          />
        </Box>
      </div>
    </div>
  )
}


